import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, X } from "lucide-react";

const ROLES = [
  { v: "superadmin", l: "Superadministrador" },
  { v: "gestor", l: "Gestor" },
  { v: "facturacion", l: "Facturación" },
  { v: "contenido", l: "Contenido / SEO" },
];

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [adding, setAdding] = useState(null);

  const load = () => adminApi.get("/admin/users").then((r) => setUsers(r.data)).catch(() => toast.error("Solo el superadmin puede gestionar usuarios"));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await adminApi.post("/admin/users", adding);
      toast.success("Usuario creado");
      setAdding(null);
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Error"); }
  };
  const del = async (id) => {
    if (!window.confirm("¿Eliminar usuario?")) return;
    try { await adminApi.delete(`/admin/users/${id}`); toast.success("Eliminado"); load(); }
    catch (err) { toast.error(err.response?.data?.detail || "Error"); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-heading font-bold text-3xl tracking-tighter">Usuarios administrativos</h1>
        <button onClick={() => setAdding({ email: "", name: "", role: "gestor", password: "" })} className="inline-flex items-center gap-2 bg-brand text-white rounded-sm px-4 py-2 text-sm font-semibold hover:bg-brand-dark" data-testid="new-user-btn"><Plus className="h-4 w-4" /> Nuevo usuario</button>
      </div>
      <div className="bg-white border border-border rounded-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-brand-ink text-white"><tr><th className="text-left px-3 py-2">Nombre</th><th className="text-left px-3 py-2">Email</th><th className="text-left px-3 py-2">Rol</th><th className="text-right px-3 py-2"></th></tr></thead>
          <tbody>
            {users.map((u, i) => (
              <tr key={u.id} className={i % 2 ? "bg-secondary/40" : "bg-white"} data-testid={`user-row-${u.id}`}>
                <td className="px-3 py-2">{u.name}</td>
                <td className="px-3 py-2 text-muted-foreground">{u.email}</td>
                <td className="px-3 py-2"><span className="text-xs bg-secondary px-2 py-0.5 rounded-sm font-mono">{u.role}</span></td>
                <td className="px-3 py-2 text-right">{u.role !== "superadmin" && <button onClick={() => del(u.id)} className="p-1.5 hover:text-destructive"><Trash2 className="h-4 w-4" /></button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {adding && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={() => setAdding(null)}>
          <div className="bg-white rounded-sm w-full max-w-md p-6 space-y-3" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between"><h2 className="font-heading font-semibold text-lg">Nuevo usuario</h2><button onClick={() => setAdding(null)}><X className="h-5 w-5" /></button></div>
            <input placeholder="Nombre" value={adding.name} onChange={(e) => setAdding({ ...adding, name: e.target.value })} className="w-full px-3 py-2 text-sm border border-border rounded-sm" data-testid="user-name" />
            <input placeholder="Email" type="email" value={adding.email} onChange={(e) => setAdding({ ...adding, email: e.target.value })} className="w-full px-3 py-2 text-sm border border-border rounded-sm" data-testid="user-email" />
            <input placeholder="Contraseña" type="text" value={adding.password} onChange={(e) => setAdding({ ...adding, password: e.target.value })} className="w-full px-3 py-2 text-sm border border-border rounded-sm" data-testid="user-password" />
            <select value={adding.role} onChange={(e) => setAdding({ ...adding, role: e.target.value })} className="w-full px-3 py-2 text-sm border border-border rounded-sm bg-white" data-testid="user-role">
              {ROLES.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
            </select>
            <button onClick={save} className="w-full bg-brand text-white py-2.5 rounded-sm font-semibold hover:bg-brand-dark" data-testid="save-user-btn">Crear usuario</button>
          </div>
        </div>
      )}
    </div>
  );
}
